import { render, staticRenderFns } from "./chat-message-order.vue?vue&type=template&id=8f8b77c4&scoped=true"
import script from "./chat-message-order.vue?vue&type=script&lang=js"
export * from "./chat-message-order.vue?vue&type=script&lang=js"
import style0 from "./chat-message-order.vue?vue&type=style&index=0&id=8f8b77c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8b77c4",
  null
  
)

export default component.exports